import React, { useState } from "react";
import styled from "styled-components";

const Avatar = ({ img, profilepic, name }) => {
  const diceBearURL = `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(
    name
  )}&size=200&backgroundType=gradientLinear&fontWeight=500`;
  const [imageSrc, setImageSrc] = useState(img || diceBearURL);

  const handleError = () => {
    if (imageSrc !== diceBearURL) {
      setImageSrc(diceBearURL);
    }
  };

  return (
    <ProfilePic
      alt="User avatar"
      src={imageSrc}
      $size={profilepic}
      onError={handleError}
    />
  );
};

const ProfilePic = styled.img`
  height: ${(props) => (props.$size ? "3rem" : "2rem")};
  width: ${(props) => (props.$size ? "3rem" : "2rem")};
  border-radius: 50%;
  margin: 0.5rem 1rem;
  object-fit: cover;
  background-color: #f0f0f0;
  cursor: pointer;
`;

export default Avatar;
